import { Button, Loader } from '@mantine/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './styles.module.css';
import useStoragePage from './useStoragePage';
import { IconPlus } from '@tabler/icons-react';
import { StorageTable } from '@/containers/pages/commonSettings/tabs/StoragePage/components/Table/StorageTable';
import MakeStorageDialog from '@/containers/pages/commonSettings/tabs/StoragePage/components/MakeStorageDialog';
import { PopUpUI } from '@components/UI/PopUp';
import { themeColors } from '@/theme/colors';

const CreateStorageTrigger = ({ handleOpenPopUp }: any) => {
  const { t } = useTranslation();

  return (
    <Button
      className={classes.addButton}
      size="sm"
      color="#667085"
      variant="outline"
      rightSection={<IconPlus color={themeColors.brandGray[0]} />}
      onClick={handleOpenPopUp}
    >
      {t('storagePage.createButton')}
    </Button>
  );
};

const StoragePage = () => {
  const { t } = useTranslation();
  const context = useStoragePage();

  const { isLoading, storages, fetchStorages } = context;

  if (isLoading) {
    return (
      <div className={classes.loadingContainer}>
        <Loader color="blue" />
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <div className={classes.title}>{t('storagePage.title')}</div>
      <StorageTable storages={storages} onUpdate={fetchStorages} />
      <PopUpUI
        mobileSize="90%"
        desktopPosition="right-start"
        trigger={(props) => <CreateStorageTrigger {...props} />}
      >
        {(popupProps) => <MakeStorageDialog {...popupProps} onSuccess={fetchStorages} />}
      </PopUpUI>
    </div>
  );
};

export default StoragePage;
